<svg width="751" height="622" viewBox="0 0 751 622" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="80.2465" cy="207.749" r="65" transform="rotate(164.195 80.2465 207.749)" fill="url(#paint0_linear_249_109)"/>
<circle cx="63.9795" cy="361.013" r="29" transform="rotate(164.195 63.9795 361.013)" fill="url(#paint1_linear_249_109)"/>
<circle cx="596.409" cy="25.4094" r="20.5818" transform="rotate(164.195 596.409 25.4094)" fill="url(#paint2_linear_249_109)"/>
<circle cx="190.409" cy="46.4094" r="20.5818" transform="rotate(164.195 190.409 46.4094)" fill="url(#paint3_linear_249_109)"/>
<circle cx="460.754" cy="331.624" r="289.5" transform="rotate(0.0755276 460.754 331.624)" fill="url(#paint4_linear_249_109)"/>
<defs>
<linearGradient id="paint0_linear_249_109" x1="80.2464" y1="272.749" x2="353.755" y2="-81.5438" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint1_linear_249_109" x1="63.9795" y1="390.013" x2="-11.2223" y2="279.112" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint2_linear_249_109" x1="596.409" y1="45.9912" x2="543.038" y2="-32.7171" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint3_linear_249_109" x1="190.409" y1="66.9912" x2="137.038" y2="-11.7171" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
<linearGradient id="paint4_linear_249_109" x1="276.254" y1="132.124" x2="854.254" y2="749.124" gradientUnits="userSpaceOnUse">
<stop stop-color="#FDC029"/>
<stop offset="1" stop-color="#F55200"/>
</linearGradient>
</defs>
</svg>
